import { render } from "./dealDetailPanel.vue?vue&type=template&id=84ead338&scoped=true"
import script from "./dealDetailPanel.vue?vue&type=script&lang=js"
export * from "./dealDetailPanel.vue?vue&type=script&lang=js"

import "./dealDetailPanel.vue?vue&type=style&index=0&id=84ead338&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84ead338"]])

export default __exports__